import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { BaseCellRendererProps } from '../Common/CellRendererProps';

export const TextCellRenderer: React.FC<BaseCellRendererProps> = (props) => {
  const [value, setValue] = useState<string>(props.value || '');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    props.node.setDataValue(props.column.colId, newValue);
  };

  const handleBlur = () => {
    // Assuming there's a parent component function to handle updates
    if (props.context?.onCellUpdate) {
      props.context.onCellUpdate(props.data, props.column.colId, value);
    }
  };

  return (
    <TextField
      size="small"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      variant="outlined"
      fullWidth
    />
  );
};